import React, { ReactNode } from 'react'

import { Typography, Box } from '@mui/material'

interface BlockWithBorderProps {
  children: ReactNode
  title?: string
  subTitle?: string
  padding?: string
  margin?: string
  height?: string
}

export const BlockWithBorder = ({
  title,
  subTitle,
  children,
  padding = '16px',
  margin = '0 0 16px',
  height,
}: BlockWithBorderProps) => (
  <>
    {title && (
      <Box mb="16px" sx={{ display: 'flex', alignItems: 'center' }}>
        {title && <Typography variant="subtitle1">{title}</Typography>}
        {subTitle && (
          <Typography px={1} sx={theme => ({ color: theme.palette.grey[400] })} variant="body2">
            {subTitle}
          </Typography>
        )}
      </Box>
    )}
    <Box
      m={margin}
      p={padding}
      height={height && height}
      /*
       * VRG-549: the handle the Studio preview's token highlight uses to point at
       * "bordered panels" when the operator asks what `secondary_color` edits. An
       * attribute rather than a class because emotion's generated class names are not
       * addressable from outside, and this panel has no stable MUI variant class of its
       * own — it is a plain `Box`. See `pages/StudioPreviewPage/tokenHighlight.ts`.
       */
      data-vera-bordered=""
      sx={theme => ({
        /*
         * `!important` is REQUIRED here, not defensive. `index.css`'s
         * `#vera-shadow-root *` rule carries ID specificity and silently
         * discards any `sx` border colour without it — which is why this panel
         * has been rendering the app's default grey rather than the tenant's
         * Studio "Border color". See `settings/tokens.ts` for the mechanism.
         */
        border: `1px solid ${theme.palette.secondary.main} !important`,
        /*
         * A panel SURFACE, so it takes a surface token — not `primary.main`.
         * Same category error as the sign-in drawer (`pages/SignIn/index.tsx`):
         * `children` render in the default `text.primary` (black), so filling
         * the panel with the accent is only legible while the accent happens to
         * be mid-tone. With the base accent now black it was black-on-black, and
         * it was already wrong for any dark tenant `primary_color`.
         */
        background: theme.palette.background.paper,
        borderRadius: '4px',
      })}
    >
      {children}
    </Box>
  </>
)
